const itemTypeEnum = Object.freeze({
    VEG: 5,
    NON_VEG: 10
});
export default itemTypeEnum;
